import { render, staticRenderFns } from "./UserDataForm.vue?vue&type=template&id=370e2097&scoped=true&"
import script from "./UserDataForm.vue?vue&type=script&lang=ts&"
export * from "./UserDataForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370e2097",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('370e2097')) {
      api.createRecord('370e2097', component.options)
    } else {
      api.reload('370e2097', component.options)
    }
    module.hot.accept("./UserDataForm.vue?vue&type=template&id=370e2097&scoped=true&", function () {
      api.rerender('370e2097', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/UserDataForm.vue"
export default component.exports